import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

// Small amber pill shown while a recovered logo waits for its print image
// (BaseLogo.awaitingImage). Purely informational — the background worker
// fills the image in automatically, typically within minutes.
export function AwaitingImageBadge({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("awaiting_image_tooltip")} placement="top">
      <span
        className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-amber-300 bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800 ${
          className ?? ""
        }`}
      >
        <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
        {t("awaiting_image")}
      </span>
    </Tooltip>
  );
}
